/**
 * The one hidden sentence every value Buddy wrote is described by (ai-plan-builder R15): „napisane
 * przez Buddy’ego". The day form renders it once; a marked cell points at it with
 * `aria-describedby`, so a listener hears it beside the value and the sentence stands only once.
 */
export const AI_WRITTEN_NOTE_ID = 'day-form-ai-written-note';
